module.exports = __webpack_public_path__ + "static/img/5areaB_6.47c80cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/5areaB_6.png
// module id = 1207
// module chunks = 1